import PropTypes from 'prop-types';
import React from 'react';

import { Cross } from '@mos-cat/icon';
import MosCatMaskedField from '@mos-cat/masked-field';

import './MaskedField.pcss';

const MaskedField = props => {
  const { clear, disabled } = props;

  return (
    <MosCatMaskedField
      {...props}
      clear={clear ? 'true' : 'false'}
      suffix={
        clear && !disabled ? (
          <Cross className="CrossIcon" onClick={clear} />
        ) : null
      }
    />
  );
};

MaskedField.propTypes = {
  clear: PropTypes.func,
  disabled: PropTypes.bool
};

export default MaskedField;
